import { Container } from '../components/ui/Container';

const timeline = [
	{
		year: '2013-2023',
		title: 'Les racines',
		desc: "Une décennie d'accompagnement entrepreneurial au Cameroun et en RDC à travers un projet de Pain pour le Monde. Les universités (ULPGL-Goma, UNIGOM, UCB) et le secteur privé collaborent pour former près de 3000 étudiants. Sur le terrain, une réalité s'impose : moins de 10% des PME accèdent au financement formel. En 2023, i-Kiotahub naît pour structurer cet accompagnement.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1743090232/kiota_suit/uejl8wcke1cctgelkwgn.jpg',
	},
	{
		year: '2023',
		title: 'La conviction',
		desc: "L'expérience terrain forge une conviction. Les PME congolaises méritent des outils pensés pour leur réalité. L'idée de Wanzo germe. Une plateforme qui connecte gestion, financement et opportunités de croissance.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1743085450/kiota_suit/z4dxuxwbkqq7xvfwxxni.jpg',
	},
	{
		year: '2024',
		title: 'Immersion et validation',
		desc: "18 mois d'immersion auprès de 50 PME. Entretiens avec banques, microfinances, fonds d'investissement et fintechs. Les défis sont identifiés, les solutions co-construites. Wanzo prend forme.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1743073969/kiota_suit/az4pccpaeiex2isq8smw.jpg',
	},
	{
		year: '2024',
		title: 'Reconnaissance internationale',
		desc: "L'approche Wanzo est distinguée au concours Just Imagine if… de l'University of Reading au Royaume-Uni. La digitalisation et le financement des PME africaines intéressent au-delà des frontières.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1742912581/kiota_suit/Aristide/acswb2x2rbxbxuc577tx.jpg',
	},
	{
		year: '2024',
		title: 'Pilote réussi',
		desc: "Validation terrain avec les premières PME partenaires. Les fonctionnalités sont testées, ajustées, optimisées. L'écosystème de partenaires financiers se structure progressivement.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1742918110/kiota_suit/x7dshq0jwbibdjzx4yqr.jpg',
	},
	{
		year: '2025',
		title: 'La co-construction continue',
		desc: "Wanzo poursuit son développement aux côtés des entrepreneurs, microfinances et institutions financières. Chaque fonctionnalité est pensée avec eux : outils de gestion, accès au financement, IA pour automatiser, blockchain pour la traçabilité. L'amélioration continue guide notre mission pour servir les besoins réels des PME africaines.",
		img: 'https://res.cloudinary.com/daxvxdecv/image/upload/v1743086219/kiota_suit/hayxezsmo4agdq4ywnkh.jpg',
	},
];

export function About() {
	return (
		<div className="relative overflow-hidden min-h-screen" style={{ background: 'linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%)' }}>
			{/* SVG curves for fluidity and section connection */}
			<svg className="absolute top-0 left-0 w-full h-32 z-0" viewBox="0 0 1440 160" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
				<path d="M0,80 C360,160 1080,0 1440,80 L1440,0 L0,0 Z" fill="#e5e7eb" />
			</svg>
			<svg className="absolute top-32 left-0 w-full h-24 z-0" viewBox="0 0 1440 96" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
				<path d="M0,48 C480,96 960,0 1440,48 L1440,0 L0,0 Z" fill="#f3f4f6" />
			</svg>
			<Container className="relative z-10 py-12 lg:py-20">
				{/* Hero Section */}
				<div
					className="relative bg-gradient-to-b from-primary-600 py-16 sm:py-24"
					style={{
						backgroundImage: `linear-gradient(to bottom, rgba(238, 242, 255, 0.6), rgba(255, 255, 255, 0.6)), url('https://res.cloudinary.com/daxvxdecv/image/upload/v1742930300/kiota_suit/wiyivnk9wgf6zvniyo0t.jpg')`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				>
					<Container>
						<div className="max-w-3xl mx-auto text-center">
							<h1 className="text-4xl font-extrabold tracking-tight text-primary-600 sm:text-5xl lg:text-6xl mb-4">
								Wanzo, une aventure collective
							</h1>
						</div>
					</Container>
				</div>

				{/* Timeline Parcours */}
				<Container>
					<div className="py-16 sm:py-24">
						<h3 className="text-primary-600 text-2xl font-bold text-center sm:text-3xl mb-12 sm:mb-16">
							Notre parcours en quelques étapes clés
						</h3>
						<div className="space-y-16 sm:space-y-24">
							{timeline.map((step, index) => (
								<div
									key={step.year + step.title}
									className={`flex flex-col items-center gap-8 sm:gap-12 lg:gap-16 ${
										index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'
									}`}
								>
									<div className="flex-1 flex flex-col justify-center">
										<div className="text-primary font-semibold text-center lg:text-left text-lg">
											{step.year}
										</div>
										<h3 className="text-xl font-bold mt-2 text-center lg:text-left sm:text-2xl">
											{step.title}
										</h3>
										<p className="mt-4 text-gray-600 leading-relaxed lg:text-left text-justify text-base">
											{step.desc}
										</p>
									</div>
									<div className="flex-1 flex justify-center items-center">
										<img
											src={step.img}
											alt={step.title}
											className="rounded-2xl shadow-2xl w-full max-w-md object-cover border border-gray-100"
										/>
									</div>
								</div>
							))}
						</div>
					</div>
				</Container>
			</Container>
		</div>
	);
}